import { Component, EventEmitter, Inject, Input, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { PDescriptionService } from '../../services/p-description.service';
import { PTicketDetailComponent } from '../pTicket/p-ticket-detail/p-ticket-detail.component';
import { pDescription } from '../../interfaces/pDescription';
import { MatRadioModule } from '@angular/material/radio';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { openSnackBar } from '../../helpers/genericFunctions';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatIconModule } from '@angular/material/icon';
import { PTicketService } from '../../services/p-ticket.service';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { pTicket } from '../../interfaces/pTicket';
import { UploadFilesComponent } from '../helpers/upload-files/upload-files.component';



/**
 * Adds descriptions to an existing tickets' communication history. Offers an input field for the new description and 
 * handlers to choose from whom the description is (Chat, Support, User).
 */
@Component({
  selector: 'app-description-new',
  standalone: true,
  imports: [ReactiveFormsModule,
    MatRadioModule,
    CommonModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatDialogModule,
    UploadFilesComponent],
  templateUrl: './description-new.component.html',
  styleUrl: './description-new.component.scss'
})
export class DescriptionNewComponent {
  constructor(
    private formBuilder: FormBuilder,
    private descriptionService: PDescriptionService,
    private pTicketService: PTicketService,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<DescriptionNewComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { ticket: pTicket; descriptions: pDescription[] }
  ) { }
  addDescriptionToTicketForm = this.formBuilder.group(
    {
      pticket_id: new FormControl(1, Validators.required),
      pde_description: new FormControl('', Validators.required),
      pde_type: new FormControl('')
    }
  )



  @Input() PTicketID!: number;
  @Input() pDescriptions!: pDescription[];
  lastDescription!: pDescription;
  editDescription!: pDescription | null;
  @Output() pDescriptionAddedEmitter = new EventEmitter();

  isLoading: Boolean = false;

  @ViewChild('fileUpload') fileUpload!: UploadFilesComponent;

  /**
   * defines ticket id and communicator type (Chat, User, Support) and submits a new description to the database API
   */
  onAddDescriptionToTicket() {


    this.addDescriptionToTicketForm.value.pticket_id = this.PTicketID;
    this.addDescriptionToTicketForm.value.pde_type = this.addDescriptionToTicketForm.value.pde_type;
    //check if form is valid
    if (this.addDescriptionToTicketForm.valid) {
      console.log("test");
      this.isLoading = true;
      this.descriptionService.create(this.addDescriptionToTicketForm.value).subscribe(
        response => {
          console.log("response");
          let ticket = {
            id: this.PTicketID,
            pct_initialdescription: response
          }
          if (this.fileUpload.files.length > 0) {
            this.fileUpload.onFileUpload(ticket).subscribe(results => {


              this.dialogRef.close();
              this.pDescriptionAddedEmitter.emit();
              this.isLoading = false;
            });
          }
          else {
            this.dialogRef.close();
            this.pDescriptionAddedEmitter.emit();
            this.isLoading = false;
          }
        });

    }
  // check if solution
  if(this.addDescriptionToTicketForm.value.pde_type === "Solution") {
  this.pTicketService.update(this.PTicketID, { pct_has_solution: "true" }).subscribe();
}

  }

onCancel(): void {
  this.dialogRef.close();
}



/**
 * Initializes the communicator type radiobutton
 */
ngOnInit() {
  this.PTicketID = this.data.ticket.id;
  this.addDescriptionToTicketForm.controls.pde_type.setValue("Support");
}

/**
 * When only enter is pressed this prevents the newline and submits the new description to the database api  
 * @param event Keyboard press event
 */
onTextareaKeydown(event: KeyboardEvent): void {
  if(event.key === "Enter" && !event.shiftKey) {
  event.preventDefault();
  this.onAddDescriptionToTicket();
}
  }

}
